import * as stagesTraffic from "../../Stages/StagesTraffic";
import { Traffic } from "../../../types/Products/TrafficLaw/Traffic/Traffic";

export const trafficRequiredFields = {
  [stagesTraffic.STAGE_INCOMPLETE]: (traffic: Traffic) => [],
  [stagesTraffic.STAGE_READY]: (traffic: Traffic) => [],
  [stagesTraffic.STAGE_CHECKED]: (traffic: Traffic) => {
    let requiredFields = ["paymentType", "responsibleAuthority", "authorityNotification"];

    if (!traffic.processStoppedDate) {
      requiredFields.push("fineNoticeReference");
    }

    if (traffic.legalExpenseInsurance === true || traffic.insuranceRequested === "yes") {
      requiredFields.push("caseInsurance.deductible", "caseInsurance.insurer", "caseInsurance.insurancePolicyNumber");
    }
    return requiredFields;
  },
  [stagesTraffic.STAGE_AUTHORIZED]: (traffic: Traffic) => trafficRequiredFields[stagesTraffic.STAGE_CHECKED](traffic),
  [stagesTraffic.STAGE_INSURANCE_COVERAGE_REQUEST]: (traffic: Traffic) => ["finalFineAmount"],
  [stagesTraffic.STAGE_ACCESS_TO_RECORDS]: (traffic: Traffic) => {
    let requiredFields = ["responsibleAuthority", "finalFineAmount"];
    if (!traffic.processStoppedDate) {
      requiredFields.push("fineNoticeReceivedDate");
      requiredFields.push("fineNoticeDate");
    }
    return requiredFields;
  },
  [stagesTraffic.STAGE_EXTRAJUDICIAL_PAID]: (traffic: Traffic) => {
    let requiredFields = ["responsibleAuthority"];
    if (traffic.paymentType === "insurance") {
      requiredFields.push("insuranceCoverageDate");
    }
    return requiredFields;
  },
  [stagesTraffic.STAGE_OPINION_SUBMITTED]: (traffic: Traffic) => {
    let requiredFields = ["responsibleAuthority", "opinionRequired"];

    if (traffic.opinionRequired) {
      requiredFields.push("opinionSubmitted");
    }
    return requiredFields;
  },
  [stagesTraffic.STAGE_AUTHORITY_ANSWERED]: (traffic: Traffic) => {
    return ["authorityAnswered", "authorityDecision", "responsibleAuthority", "opinionRequired"];
  },
  [stagesTraffic.STAGE_TRIAL]: (traffic: Traffic) => {
    return ["trialWanted", "responsibleCourtAddress.postalCode", "responsibleAuthority"];
  },
  [stagesTraffic.STAGE_TRIAL_DATE_SET]: (traffic: Traffic) => {
    return ["courtNotice", "courtReference", "responsibleAuthority"];
  },
  [stagesTraffic.STAGE_TRIAL_PAID]: (traffic: Traffic) => {
    if (traffic.paymentType !== "private") {
      return [];
    }

    return ["responsibleAuthority"];
  },
  [stagesTraffic.STAGE_DECISION_MADE]: (traffic: Traffic) => {
    if (traffic.processStoppedDate) {
      return [];
    }

    let requiredFields = ["responsibleAuthority"];

    if (traffic.legalExpenseInsurance === true || traffic.insuranceRequested === "yes") {
      requiredFields.push("caseInsurance.deductible");
    }

    if (traffic.courtNotice === "trial" && traffic.appealRevoked === null) {
      requiredFields.push("courtDecisionDate");
    }

    if (traffic.paymentType !== "private") {
      requiredFields.push("caseInsurance.caseReferenceNumber");
    }

    return requiredFields;
  },
  [stagesTraffic.STAGE_COMPLETED]: (traffic: Traffic) => {
    return ["responsibleAuthority"];
  },
};
